import styled from 'styled-components';

import { Color } from '../../../../constants/Colors';
import { MediaQuery } from '../../../../constants/Styles';

export const MainNav = styled.nav`
  height: 100%;
  width: 100%;
  display: ${({ isMobile }) => (isMobile ? 'none' : 'flex')};
  justify-content: flex-end;

  ${MediaQuery.L_AND_DOWN} {
    display: ${({ isMobile, isVisible }) =>
      isMobile && isVisible ? 'initial' : 'none'};
    background-color: ${Color.WHITE};
  }
`;

export const MenuLink = styled.ul`
  height: 100%;
  display: ${({ isMobile }) => (isMobile ? 'grid' : 'flex')};
  margin: ${({ isMobile }) => (isMobile ? '5px 30px' : '0')};

  & > a {
    margin-right: 15px;
    padding-left: 6px;

    ${MediaQuery.L_AND_DOWN} {
      display: block;
      text-align: center;
    }
  }
`;
